export default __webpack_public_path__ + "static/media/cabinet1-after.5938d730.jpg";